import React, {  useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Modal from "./Modal";
import Ctus from './ShowMap';
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL} from '../utils/common';
import { useReactToPrint } from 'react-to-print';
//import { useDownloadExcel } from "react-export-table-to-excel";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const DeviceList = () => 
{           
            
            const fileType ="xlsx";
            const tableRef = useRef(null);
            const API_URL=aPIURL();
            const AUTH_URL= auTHURL();
            const [groupId, setGroupId]= useState('1');
            let [devModel, setDevModel]= useState('GPS-V5');
            const [timeZoneId, setTimeZoneId]= useState('');
            const [actionId,setActionId]= useState('1');
            const [dstatusId,setDstatusId]= useState();
            const [dID,setDID]= useState('0');
            const [dActionname,setDActionname]= useState('Save');
            const [saleSubscriptionType,setSaleSubscriptionType]= useState('1');
            const [custID,setCustID]= useState('0');
            const [sAlert,setsAlert]= useState('0');
            const [groupData,setGroupData]= useState([]);
            const [timeZoneData,setTimeZoneData]= useState([]);
            const [statusData,setStatusData]= useState([]);
            const [deviceData,setDeviceData]= useState([]);
            const [customerData,setCustomerData]= useState([]);
            const [filteredDevicedata,setFilteredDevicedata]= useState([]);
            const [filteredCustomerdata,setFilteredCustomerdata]= useState([]);
            const [allotedDeviceByCustID, setAllotedDeviceByCustID]= useState([]);
            const [subscriptionData,setSubscriptionData]= useState([]);
            const [showAddDetails,setShowAddDetails]= useState(false);
            const [showDetails,setShowDetails]= useState(false);
            const [showLocation ,setShowLocation]= useState(false);
            const [showSale,setShowSale]= useState(false);
            const [showActivate,setShowActivate] = useState(false);
            const [showDeactivate,setShowDeactivate]= useState(false);
            const [showAlert,setShowAlert]= useState(false);
                
            const [post, setPost] = useState([]);
            const [order, setOrder] = useState("ASC");
            const [number, setNumber] = useState(1); // No of pages
            const [postPerPage] = useState(10);
            const [inputs, setInputs] = useState({});
            const [inputsSale, setInputsSale] = useState({});
            let [isRelay,setIsRelay]=useState(0); 
            let [devIMEINumber , setDevIMEINumber]= useState('');   
            let [devSimNumber , setDevSimNumber]= useState('');   
            let [devTypeId, setDevTypeId]= useState(0);

            useEffect(() => {
       
                FillGrid(0);// Zero for All
                const surls=API_URL+'GpsDeviceGroup';
                axios.post(surls).then(response => {                            
                setGroupData(response.data.data)
                }).catch(function(error){console.log(error.message);});
                
                //grid binding start 
                const durls=API_URL+'TimeZone/';
                
                axios.post(durls).then(response => {                            
                setTimeZoneData(response.data.data)
                }).catch(function(error){console.log(error.message);});
            
                setStatusData([{displayName: "Enabled", statusValue: "1",  stausId: 1},{displayName: "Disabled", statusValue: "0",  stausId: 0},{displayName: "Unassigned", statusValue: "4",  stausId: 4},{displayName: "Hold", statusValue: "3",  stausId: 3}]);
                 
            }, []);
              
              const lastPost = number * postPerPage;
              const firstPost = lastPost - postPerPage;
              const currentPost = post.slice(firstPost, lastPost);
              const PageCount = Math.ceil(post.length / postPerPage);
  
  const ChangePage = ({ selected }) => {
        
                setNumber(selected+1);
          };

const sorting=(col)=>
          {
          
            try
            {
              if(order==="ASC")
              {
                      const sorted=[...post].sort((a,b)=>
                      a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
                      );
                      setPost(sorted);
                      setOrder("DSC");
              }
              if(order==="DSC")
              {
                      const sorted=[...post].sort((a,b)=>
                      a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
                      );
                      setPost(sorted);
                      setOrder("ASC");
              }
            }
            catch(error) 
            {
              console.log(error.message);
            }                      
          }

const FillGrid=(Type_ID)=>
{
    const curls=API_URL+`GpsAdminDeviceAllList/?TypeID=${Type_ID}&IMEINumber=0&SimNumber=0`;  
   
    setPost([]);
    axios.post(curls).then(response => {   
                    
    setPost(response.data.data);
    //console.log(response.data.data);  

     }).catch(function(error){console.log(error.message);});
}
const FilterGrid=()=>
  {
    const fcurls=API_URL+`GpsAdminDeviceAllList/?TypeID=${devTypeId}&IMEINumber=${devIMEINumber}&SimNumber=${devSimNumber}`;  
    
    setPost([]);
    axios.post(fcurls).then(response => {   
                    
    setPost(response.data.data);
    //console.log(response.data.data);  

     }).catch(function(error){console.log(error.message);});
  }
const showAddDeviceDetails=()=>
 {
    
    setActionId('1'); 
    setDActionname('Save');
    setInputsSale({});
    setShowDetails(false);  
    setShowAddDetails(true);
    setShowSale(false);
    setShowActivate(false); 
    setShowLocation(false);
    setShowDeactivate(false);
    setDstatusId(0);
    setIsRelay(0);
 }       
 const showDetailsModal = (index) => {
            
       
        const d_Id = index;                           
        const urls=API_URL+`GetDeviceDetails/${d_Id}/`;         
        axios.post(urls).then(response => {                  
        setFilteredDevicedata(response.data.data);
        }).catch(function (error) { console.log(error.message); });   
                
        setShowDetails(true);  
        setShowAddDetails(false);
        setShowSale(false);
        setShowActivate(false); 
        setShowLocation(false);
        setShowDeactivate(false);
    }
   
const showLocationDetailsModal = (index) => {
        const d_Id = index;                           
        const urls=API_URL+`GetDeviceDetails/${d_Id}/`;
        axios.post(urls).then(response => {                  
        setFilteredDevicedata(response.data.data);
        }).catch(function (error) { console.log(error.message); });         
            setDID(d_Id); 

        setShowDetails(false);  
        setShowAddDetails(false);
        setShowSale(false);
        setShowActivate(false); 
        setShowLocation(true);
        setShowDeactivate(false);
    }

const showSaleDetailsModal = (index) => {
            
        const d_Id = index;                            
        const urls=API_URL+`GetDeviceDetails/${d_Id}/`;    
        axios.post(urls).then(response => {                  
        setFilteredDevicedata(response.data.data);
        }).catch(function (error) { console.log(error.message); });   
      
        axios.post(API_URL+'GpsCustomerAllList/?TypeID=1').then(response =>
           {
            //console.log(response.data.data);
            const updatedCustomerList = response.data.data.filter((curElem) =>
             {
                //console.log(curElem);
                return curElem.status === "Active";

         });
              setCustomerData(updatedCustomerList);                 
        }).catch(function (error) { console.log(error.message); });   
          
        axios.get(API_URL+'Subscribe').then(response => {
            //console.log(response.data.data);
           
            setSubscriptionData(response.data.data);                 
        }).catch(function (error) { console.log(error.message); });   
              
        //console.log("Start");                         
            
        setDID(d_Id);  
        setShowDetails(false);  
        setShowAddDetails(false);
        setShowSale(true);
        setShowActivate(false); 
        setShowLocation(false);
        setShowDeactivate(false);   
    } 
/*
    const showActivateDetailsModal = (index) => {
        this.setState({ showAddDetails: false});   
        this.setState({ showDetails: false });  
        this.setState({ showSale: false });
        this.setState({ showActivate: true }); 
        this.setState({ showLocation: false });
        this.setState({ showDeactivate: false });
    } 

    const showDeactivateDetails = (index) => {
        const updatedList = this.state.DeviceData.filter((curElem) => {
        return curElem.id === index;
        });          
        this.setState({ FilteredDevicedata: updatedList});  

            setShowAddDetails(false);
            setShowDetails(false);
            setShowLocation(false);
            setShowSale(false);
            setShowActivate(false);
            setShowDeactivate(true);    
    }    
   */
const closeModal = () => {
            setShowAddDetails(false);
            setShowDetails(false);
            setShowLocation(false);
            setShowSale(false);
            setShowActivate(false);
            setShowDeactivate(false);         
}
const closeAddDeviceModal = () => {
            setActionId('1'); 
            setDActionname('Save');
                        
            inputs.DIMEI= "";
            inputs.AVTIMEI= "";
            inputs.DevMobile= "";
            inputs.Dremark= "";

            setShowAddDetails(false);
            setShowDetails(false);
            setShowLocation(false);
            setShowSale(false);
            setShowActivate(false);
            setShowDeactivate(false);  
            setIsRelay(0); 
            bindDeviceDetails();   

}
const handleChange = (event) => 
  {  
    setIsRelay(event.target.value);
  };
const deviceAllottment=(iemiNumber) => {
       
       
    if(saleSubscriptionType === '0')
    {
        toast.error("Please select subscription duration.");
        return;
    }
    else if(custID==='0')
    {
        toast.error("Please select customer.");
        return;
    }
    else if((!inputsSale.SaleBy) || inputsSale.SaleBy ==='')
    {
        toast.error("Sales person is required.");
        return;
    }
    else
    {
           //Insert Sale Device Details
           const params = JSON.stringify({
            "accountID": custID,
            "allotmentID": 0,
            "imeiNumber": iemiNumber,
            "allotmentBy": inputsSale.SaleBy,
            "allotyName": inputsSale.SaleAllotteeName,
            "deviceID": dID,
            "subscribeID": saleSubscriptionType
         
       });
         

        axios.post(API_URL+'AllotmentDevice/', params, {
    
             "headers": 
             {
                    "content-type": "application/json",    
             },
    
        })
          .then(function (response) 
          {
            toast.success(response.data.message);              
               
          })
    
          .catch(function (error) 
          {
                //toast.error("Some Error occured while saving record.");
                //toast.error(error);
                console.log(error.message);    
          });
            
            handleClear();               
        }                
}
 

const deviceDeAllottment=(allotmentID) => {
   
    if(window.confirm('Are sure want to delete?'))
             {
                const dallot_Id = allotmentID;     
                const durls=API_URL+`AllotmentDeviceDelete/${dallot_Id}/`; 
                
                axios.delete(durls).then(response => {                  
                    toast.success(response.data.message);    
                })                   
                .catch(function (error) 
                {
                    console.log(error.message);    
                });
                
                handleClear();
    } 
    else 
    {
            toast.error('Delete operation canceled by the user.');
    }
     
          
         
         setShowSale(false);
         setShowAlert(true);
         
         if(sAlert==1)
         {
                const dallot_Id = allotmentID;     
                
                const durls=API_URL + `AllotmentDeviceDelete/${dallot_Id}/`; 
               
                axios.delete(durls).then(response => {                  
                        alert(response.data.message);    
                })                   
                .catch(function (error) 
                {
                   console.log(error);    
                });
                                
                handleClear();
        }        
       }
                  
const ChangeDGroup = (e) => {

            setGroupId(e.target.value);        
        }
    
const ChangeTimeZone = (e) => {
    
        setTimeZoneId(e.target.value);  
               
        }
const ChangeDModel = (e) => {

          //inputs.DModel = e.target.value;
          setDevModel(e.target.value);     
        }        
const ChangeDStatus = (e) => {
    
            setDstatusId(e.target.value);      
            
        }
const ChangeCustomerID = (e) => {

        setCustID(e.target.value);
        bindAllottedDevice(e.target.value);
    }

const ChangeSubscriptionType = (e) => {

        setSaleSubscriptionType(e.target.value);
    }
const changeHandler = (e) => {

        const name = e.target.name;
        const value = e.target.value;
        setInputsSale(values => ({...values, [name]: value}))
      }    
const bindAllottedDevice=(ca_Id)=>
{
    
    setAllotedDeviceByCustID([]);
    const aurls = API_URL+`AllotmentDeviceList/?AccountID=${ca_Id}`;    
    
    axios.get(aurls).then(response => 
      {                        
    setAllotedDeviceByCustID(response.data.data);
    }).catch(function (error) { console.log(error.message); });      
}

const onClickRegister = () => {
    
    setActionId('1'); 
    if((devModel=='') || (!devModel))
    {
        devModel = "GPS-V5";
    }    
    if(devModel==='')
    {
        toast.error("Device model is required.");
        return;
    }
   else if(!inputs.DIMEI)
    {
      
       toast.error("Device IMEI is required.");
       return;
    }
    else if(inputs.DIMEI.length<16 || inputs.DIMEI.length>16)
      {
        toast.error("Device IMEI should be 16 digits.");
        return;
      }

    else if(!groupId)
    {
        toast.error("Make is required.");
        return;
    }
    else if(groupId==='')
    {
        toast.error("Make is required.");
        return;
    }
    else if(!inputs.AVTIMEI)
      {
         toast.error("Device AVT IMEI is required.");
         return;
      }    
    else if(dstatusId==='')
    {
        toast.error("Status is required.");
        return;
    }       
  else  
  {
   
   if(actionId=='1')
   {
       
       //Insert Device Details
       const params = JSON.stringify({

      "iemiNumber": inputs.DIMEI,
      "AVTIMEI":inputs.AVTIMEI,
      "IS_Relay" :isRelay,
      "deviceName": "GPS",
      "mobileNumber": inputs.DevMobile,
      "model": devModel,
      "goupID": groupId,
      "timeZone": timeZoneId,
      "createdBy": "admin",
      "is_Active": dstatusId,
      "remarks": inputs.Dremark
    });
     

    axios.post(API_URL+'GpsDeviceRegistration/', params, {
         "headers": 
         {
                "content-type": "application/json",    
         },
    })
      .then(function (response) 
      {
           if(!response.data.validStatus)
           {
                   toast.error(response.data.message);
                   return;
           }
           else
           {
                  toast.success(response.data.message);
                 //console.log(response.data);
         }
                       
           
      })

      .catch(function (error) 
      {
              toast.error(error.message);
              console.log(error);    
      });
            
        handleAddDeviceClear();
                  
    } 
    else
    {
        
        //Update Device Details
       const params = JSON.stringify({
        "id": dID,
        "iemiNumber": inputs.DIMEI,
        "AVTIMEI":inputs.AVTIMEI,
        "IS_Relay" :isRelay,
        "deviceName": inputs.DeviceName,
        "mobileNumber": inputs.DevMobile,
        "model": devModel,
        "goupID": groupId,
        "timeZone": timeZoneId,
        "createdBy": "admin",
        "is_Active": dstatusId,
        "remarks": inputs.Dremark           
       
      });
       

      axios.post(API_URL+'GpsDeviceEdit/', params, {
  
           "headers": 
           {
                  "content-type": "application/json",    
           },
  
      })
      .then(function (response) 
        {
           if(!response.data.validStatus)
           {
                    toast.error(response.data.message);
                    return;
           }
           else
           {
                 toast.success(response.data.message);                 
           }         
               
        })      
       .catch(function (error) 
        {
            console.log(error);    
        });
            handleUpdateDeviceClear();                
    }
}
}

const handleClear=()=>
{
        inputsSale.SaleSubscriptionType=0;
        inputsSale.Saleby="";        
        //bind device details grid
        bindAllottedDevice(custID);                          
}

 
const changeAddDeviceHandler = (e) => {

 /*if(e.target.name==='DIMEI')
  {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) 
        {
         
              const name = e.target.name;
             
             const value = e.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['DIMEI']: ""}))
              
        }
        
  }
  
  else */
  if(e.target.name==='DevMobile')
  {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) 
        {
         
              const name = e.target.name;
             
             const value = e.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['DevMobile']: ""}))
              
        }
        
  }
  else
  {
                const name = e.target.name;
                const value = e.target.value;
                setInputs(values => ({...values, [name]: value}))
  }
}

const handleEdit=(index) => {
            
    const D_Id = index;                   
    const urls = API_URL+`GetDeviceDetails/${D_Id}/`;
    
    
    axios.post(urls).then(response => 
    {
        console.log("---------------start---------------");
        console.log(response.data.data[0]);                  
        setActionId('2'); 
        setDActionname('Update');
        setDID(response.data.data[0].id);  
        setGroupId(response.data.data[0].groupID); 
        setTimeZoneId(response.data.data[0].timeZone);          
        console.log(response.data.data[0].id);
         
        //inputs       
        inputs.DIMEI= response.data.data[0].iemiNumber;
        inputs.AVTIMEI= response.data.data[0].avtimei;
        devModel = response.data.data[0].model;
        inputs.DeviceName= response.data.data[0].deviceName;
        inputs.DevMobile= response.data.data[0].mobileNumber;
        inputs.DGroup= response.data.data[0].goupID;
        inputs.DTimeZone= response.data.data[0].timeZone;
        inputs.DStatus= response.data.data[0].is_Active;
        inputs.Dremark= response.data.data[0].remarks;
        setDstatusId(response.data.data[0].is_Active);
        setIsRelay(response.data.data[0].iS_Relay)
        
       
    
  });                                                        
   
        setShowAddDetails(true);
        setShowDetails(false);
        setShowLocation(false);
        setShowSale(false);
        setShowActivate(false);
        setShowDeactivate(false);            
}
const styles = {
    headsection: {
        backgroundColor:"black", color:"white",textAlign:"center"
    },
    wrapper: {
      textAlign: "center",
      margin: "0 auto",
      marginTop: "50px"
    }
  }
  const handleAddDeviceClear=()=>
  {

        setActionId('1'); 
        setDActionname('Save');
        setGroupId('1'); 
        setTimeZoneId('');   
        setDstatusId(0);
        setDID('0');          
        setDeviceData([]);    
        inputs.DIMEI= "";
        inputs.AVTIMEI= "";
        inputs.DevMobile= "";
        inputs.Dremark= "";
        //bind device details grid
        bindDeviceDetails();          
  }
  const handleUpdateDeviceClear=()=>
  {
      setGroupId('1'); 
      setTimeZoneId('');   
      setDID('0');          
      setDeviceData([]);      
      //bind device details grid
      bindDeviceDetails();   
         
  }
  const bindDeviceDetails=()=>
  {
    FilterGrid();
    //FillGrid(0);    
  }
  const exportStatus = e => {
 
    const value = e.target.value;
    setDevTypeId(e.target.value);
   
    FillGrid(value);
  }

  const exportToCSV=()=>
    {
      const newPost = post.map(({ createdBy,deviceID,groupName,timeZone, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:5} ,
          {wch:10},
          {wch:20},
          {wch:10},
          {wch:20},
          {wch:20},
          {wch:20},    
          {wch:10}
      ];
   
      var wsrows = [
         {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['S.No.','NAME','IMEI NUMBER','MODEL','SIM NUMBER','ACTIVATION DATE','EXPIRATION DATE','STATUS']];
      const wb={Sheets:{Devices:ws},SheetNames:["Devices"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AvtDeviceReport"+".xlsx");
     }
const DIMEIchangeHandler=(e)=>
{
      setDevIMEINumber(e.target.value)
}
const DSimchangeHandler=(e)=>
{
    setDevSimNumber(e.target.value)
}
const ResetList=()=>
{
      setDevIMEINumber("");
      setDevSimNumber("");
      
      FillGrid(0);
}
const exportDownload = e => 
{  
  
  const value = e.target.value; 
  

  if(value=="Excel")
  {
        exportToCSV();   
      // onDownload();
  }
  if(value=="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}
/*const { onDownload } = useDownloadExcel({
  currentTableRef: tableRef.current,
  filename: "Device Details",
  sheet: "Devices"
});*/
const handlePrint = useReactToPrint({
  documentTitle: "Device Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});

  return (
    <>   
        <div>
          {/*Show Device Model*/}
        <Modal isOpen={showDetails} >  
               
              <div class="modal-header">
                <h5 className='modal-title'>View Details</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                <div class="modal-body">   

                    <div class="container">
   
    <div class="row">
     
      <div class="col-md-12">
      <div class="accordion" id="AVTFAQ">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq-1" aria-expanded="true" aria-controls="collapseOne">
     Customer Details
      </button>
    </h2>
    <div id="faq-1" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p>  <table >
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                    <td>                    
                    <div class="row">
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Cutomer Name : </b>        
                    {devdata1.company}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Mobile No : </b>        
                    {devdata1.customerMobile}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Email : </b>        
                    {devdata1.customerEmail}
                    </div>
                     <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Country : </b>        
                    {devdata1.customerCountry}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> State : </b>        
                    {devdata1.customerState}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> City : </b>        
                    {devdata1.customerCity}
                    </div>
                     <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Pincode : </b>        
                    {devdata1.customerPincode}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Customer Type : </b>        
                    {devdata1.customerType}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;                     
                    </div>
                    </div>               
                    </td>                            
                </tr>
                 ))}
                </table></p>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
   <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-2" aria-expanded="false" aria-controls="collapseTwo">    
      Device Details 
      </button>
      
    </h2>
    <div id="faq-2" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p>  <table >
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                    <td>                    
                    <div class="row">
                    
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Device Name : </b>        
                    {devdata1.deviceName}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Model : </b>       
                    {devdata1.model}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> IMEI No : </b>      
                    {devdata1.iemiNumber}
                    </div>                                   
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> SIM No : </b>       
                    {devdata1.mobileNumber}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Group : </b>        
                    {devdata1.groupName}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Time-Zone : </b>      
                    {devdata1.timeZone}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Activation Date : </b>        
                    {devdata1.activationDate}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Expiration Date : </b>       
                    {devdata1.expirationDate}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Status : </b>        
                   {devdata1.status}                   
                    </div>                    
                    </div>               
                    </td>                            
                </tr>
                 ))}
                </table></p>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-3" aria-expanded="false" aria-controls="collapseThree">
      Driver Details 
      </button>
    </h2>
    <div id="faq-3" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p> <table >
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                <td>                    
                <div class="row">                
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Driver Name : </b>      
                    {devdata1.driverName}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Father Name : </b>       
                    {devdata1.fatherName}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Contact No : </b>        
                    {devdata1.contactNumber}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> License No : </b>       
                    {devdata1.licenceNumber}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> License From : </b>        
                    {devdata1.licenceIssueFrom}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> License Validity : </b>      
                    {devdata1.licenceValidity}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Address : </b>        
                    {devdata1.address}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Identity No : </b>       
                    {devdata1.identityNumber}
                    </div>
                </div>                  
                </td>                            
                </tr>
                 )             
                )
                }
                </table></p>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-4" aria-expanded="false" aria-controls="collapseThree">
      Vehicle Details 
      </button>
    </h2>
    <div id="faq-4" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p> <table>
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                    <td>                    
                    <div class="row">
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Vehicle No : </b>      
                    {devdata1.vehicleNumber}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> VIN : </b>       
                    {devdata1.vin}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Engine No : </b>        
                    {devdata1.enginNumber}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Vehicle Brand : </b>       
                    {devdata1.vehicleBrand}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Vehicle Model : </b>        
                    {devdata1.vehicleModel}
                    </div>                   
                </div>
                </td>                            
                </tr>
                 )             
                )
                }
                </table> </p>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-5" aria-expanded="false" aria-controls="collapseThree">
      Peripheral Details 
      </button>
    </h2>
    <div id="faq-5" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p> <table>
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                <td>                    
                <div class="row">
                <div class="col-sm-12 col-md-12 form-group">&nbsp;
                    <b>Relay : </b>                
                    {devdata1.iS_Relay==1? "Active Relay(OTP)": devdata1.iS_Relay==2 ? "Active Relay(NO OTP)":"Non-Active Relay"}
                    </div>                   
                </div>
                </td>                            
                </tr>
                 )             
                )
                }
                </table> </p>
           
      </div>
    </div>
  </div>
</div>          
</div>
</div>
</div>                         
              
                </div>
        </Modal>
 {/*Add Device Model*/}
  <Modal isOpen={showAddDetails} >  
        <div class="modal-header">
        <h5 className='modal-title'>{dActionname} Device</h5>
        <button type="button" class="btn-close" onClick={closeAddDeviceModal}></button>
        </div>
        <div class="modal-body">                            
        <div class="row">      
		<div class="col-sm-6 col-md-6 form-group">
		Model<span style={{color:"red"}}>&nbsp;*</span>
        <select className="form-control" name="DGroup" value={devModel} onChange={ChangeDModel}  >
         <option value={"GPS-V5"}>GPS-V5</option>        
         <option value={"VL-149"}>VL-149</option>               
         <option value={"WETRACK-140"}>WETRACK-140</option>
        </select>
        
	    </div>
		
        <div class="col-sm-6 col-md-6 form-group">
		Device IMEI<span style={{color:"red"}}>&nbsp;*</span>        
        <input name="DIMEI"  type="text" required="required"  className="form-control" maxLength={16} value={inputs.DIMEI} onChange={changeAddDeviceHandler} ></input>
		</div>
		
		<div class="col-sm-6 col-md-6 form-group">
		SIM Number
        <input name="DevMobile" type="text" required="required" className="form-control" maxLength={13} value={inputs.DevMobile} onChange={changeAddDeviceHandler} ></input>
		</div>
		<div class="col-sm-6 col-md-6 form-group">
    AVT IMEI<span style={{color:"red"}}>&nbsp;*</span>
        <input name="AVTIMEI" type="text" className="form-control" value={inputs.AVTIMEI} onChange={changeAddDeviceHandler} ></input>
	  </div>
    <div class="col-sm-6 col-md-3 form-group">
    Non-Active Relay
    <input type="radio" groupName="a" value="0" checked={isRelay == 0}  onChange={handleChange} ></input>
    </div>
    <div class="col-sm-6 col-md-3 form-group">
    Active Relay(OTP)
    <input type="radio" groupName="a"  value="1" checked={isRelay == 1}  onChange={handleChange}  ></input>
    </div> 
    <div class="col-sm-6 col-md-3 form-group">
    Active Relay(NO OTP)
    <input type="radio" groupName="a"  value="2" checked={isRelay == 2}  onChange={handleChange}  ></input>
    </div> 
	<div class="col-sm-6 col-md-6 form-group">
		Make<span style={{color:"red"}}>&nbsp;*</span>
        <select className="form-control" name="DGroup" value={groupId} onChange={ChangeDGroup}  >
         
         {groupData.map((e, key) => {
         return <option key={key} value={e.groupID}>{e.groupName}</option>;
         })}
        </select>
		</div>
    
      
		<div class="col-sm-6 col-md-6 form-group">
		Time-Zone<span style={{color:"red"}}>&nbsp;*</span>
        <select className="form-control slct" name="DSTimeZone" value={timeZoneId} onChange={ChangeTimeZone} >
             {timeZoneData.map((e, key) => {
             return <option key={key} value={e.timeValue}>{e.displayName}</option>;
            })}

        </select>
		</div>
		<div class="col-sm-6 col-md-6 form-group">
		Status<span style={{color:"red"}}>&nbsp;*</span>
        <select className="form-control slct" name="DStatus" value={dstatusId} onChange={ChangeDStatus} >
           
           {statusData.map((e, key) => {
             return <option key={key} value={e.statusValue}>{e.displayName}</option>;
            })}

        </select>
       
   	</div>
     
    <div class="col-sm-12 col-md-12 form-group">
    Remarks
        <input name="Dremark" type="text" className="form-control" value={inputs.Dremark} onChange={changeAddDeviceHandler} ></input>
	</div>
  
    <div class="col-sm-12 col-md-12 form-group">
    <center>
              <button type="submit" id="Save" onClick={onClickRegister} className="btn btn-primary2">{dActionname} </button>                
    </center>
    </div>
	</div>
                </div>
        </Modal>
            
        <Modal isOpen={showLocation} >
                <div class="modal-header">
                <h5 className='modal-title'>Device Location Details</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                <div class="modal-body">
                
                <div class="row">
                <Ctus id= {dID}/>
                       </div> </div>
        </Modal>
              
        <Modal isOpen={showSale}>
                <div class="modal-header">
                <h5 className='modal-title'>Sale Device</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                <div class="modal-body">             
                
                <table>
               
                {filteredDevicedata.map(devdata1 => (
                
                <tr key={devdata1.id}>
                <td> 
                <div class="row">
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> IEMI Number : </b> 
                {devdata1.iemiNumber}

                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Device Name : </b> 
                {devdata1.deviceName}

                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Device Model : </b> 
                {devdata1.model} 

                </div>
               
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Subscription Duration : </b> <span style={{color:"red"}}>&nbsp;*</span>  
                    <select className="form-control"  name="DSubscriptionType" value={inputsSale.SaleSubscriptionType} onChange={ChangeSubscriptionType} >
                    <option value={0}>Select Subscription Duration</option>
                    {subscriptionData.map((e, key) => {
                     return <option key={key} value={e.id}>{e.subscribeName}</option>;
                    })}
                    </select>  
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Customer : </b> <span style={{color:"red"}}>&nbsp;*</span> 
                    <select className="form-control"  name="DCustomerID" value={custID} onChange={ChangeCustomerID} >
                    <option>Select Customer</option>
                    {customerData.map((e, key) => {
                     return <option key={key} value={e.accountID}>{e.customerName}({e.companyName})</option>;
                    })}
                    </select>

            </div>
            <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Sales Person : </b> <span style={{color:"red"}}>&nbsp;*</span>  
            <input name="SaleBy"  type="text"   className="form-control"  value={inputsSale.SaleBy} onChange={changeHandler}></input>

            </div>
            <div class="col-sm-6 col-md-4 form-group"></div><div class="col-sm-6 col-md-4 form-group"></div>
            <div className='col-md-6 col-lg-4 form-group' >
            <button style={{"float": "right"}} type="submit" id="Sell" onClick={() => deviceAllottment(devdata1.iemiNumber)} className="btn btn-primary2">Sell </button>  
           
            </div>
            <div className='col-md-6 col-lg-4 form-group'>

            </div>
            <div className='col-md-6 col-lg-4 form-group'>

            </div>
                </div>                                              
                </td>
                </tr>          
                 ))}
                </table>
                             
              <b>  Previously Sold Device</b>
                <table class="table table-striped table-bordered table-hover">
                    <thead> 
                    <tr>
                    <th >Device Name</th>
                    <th >IMEI Number</th>                    
                    <th >Sell Date</th>                                     
                    <th >Subscribtion Duration</th>
                   
                    <th >Action</th>
                    </tr>
                    </thead>
                     <tbody>
               
                {allotedDeviceByCustID.map(devalldata => (
                <tr key={devalldata.allotmentID}>
                <td>{devalldata.deviceName}</td>
                <td>{devalldata.imeiNumber}</td>
                <td>{devalldata.allotmentDate}</td> 
                <td>{devalldata.subscribeName}</td> 
                        
                <td style={{textAlign:"center" }}><i onClick={() => deviceDeAllottment(devalldata.allotmentID)} style={{ color:"red", cursor:'pointer', fontSize:"17px",  "font-weight":"bold" }} className="fa-solid fa-trash" title="DeAllottment"></i></td> 
                          
                </tr>
              )                   
              )
              }      
               </tbody>
               </table>   
            
                </div>
               
         </Modal>
             
                    
        </div>
        {/**/}
        <div className="top-bar clearfix">
        <div className="row">
       
        <div className="col-md-4">
        <h2> Devices </h2>           
        </div>
          <div className="col-md-8 text-right">
          <button type="submit" id="new" onClick={() => showAddDeviceDetails()} className="btn btn-new"> New </button>                  
          <select onChange={exportStatus} className="btn btn-primary" name="Export">
          <option value={"0"}>All</option>    
          <option value={"1"}>Enabled</option>  
          <option value={"2"}>Disabled</option>   
          <option value={"3"}>Hold</option>   
          <option value={"4"}>Unassigned</option>
          <option value={"5"}>Distribuitor Issued</option>
          <option value={"6"}>Inventory</option>
          <option value={"9"}>Deactivated</option>
          </select> 
          <select onChange={exportDownload} className="btn btn-primary" name="Download" >
          <option value={"Download"}>Download</option>    
          <option value={"Excel"}>Excel</option>    
          <option value={"PDF"}>PDF</option>                      
          </select>
          </div>
        </div>
      </div>    
      <div className="container-fluid p-3">
      <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
    <div class="row align-items-end">  
    <div class="col-sm-3 col-lg-2">IMEI NUMBER <input type="text" class="form-control" tabindex="1" id="txtImeiNumber"   maxlength="20" value={devIMEINumber} onChange={DIMEIchangeHandler}/>
    </div>
    <div class="col-sm-3 col-lg-2">Sim NUMBER <input type="text" class="form-control" tabindex="2" id="txtSimNumber"   maxlength="20" value={devSimNumber} onChange={DSimchangeHandler}/>
    </div>
    
    <div class="col-sm-4 col-lg-2">
    <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnSearchNew" onClick={FilterGrid} >Search</button>
    <button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="4" onClick={ResetList}>Reset
    </button></div>
    <div class="col-sm-3 col-lg-2"> </div>
    </div>    
  </div></div>
  <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body p-0">
    <table ref={tableRef}  id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
    <thead>
    <tr><th width="3%" >S.No.</th>
    <th width="5%" onClick={()=>sorting("deviceName") } style={{textAlign:"center","cursor": "pointer"}}>NAME &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="7%" onClick={()=>sorting("model") } style={{textAlign:"center","cursor": "pointer"}}>MODEL &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("imeiNumber") } style={{textAlign:"center","cursor": "pointer"}}>IMEI NUMBER &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("mobileNo") } style={{textAlign:"center","cursor": "pointer"}} >SIM NUMBER &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="9%" onClick={()=>sorting("groupName") } style={{textAlign:"center","cursor": "pointer"}}>MAKE &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="8%" onClick={()=>sorting("timeZone") } style={{textAlign:"center","cursor": "pointer"}}>TIME-ZONE &nbsp;<i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("activationDate") } style={{textAlign:"center","cursor": "pointer"}}>ACTIVATION DATE &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("expirationDate") } style={{textAlign:"center","cursor": "pointer"}}>EXPIRATION DATE &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("logUpdate") } style={{textAlign:"center","cursor": "pointer"}}>Log Update &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="8%" onClick={()=>sorting("status") } style={{textAlign:"center","cursor": "pointer"}}>STATUS &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("id") } style={{textAlign:"center"}}>Action </th>
    </tr>
    </thead>
    <tbody>
    {currentPost.map((devdata) => {
                return (
                <tr key={devdata.id}>
                  <td style={{textAlign:"center"}}>{devdata.id}</td>
                  <td style={{textAlign:"center"}}>{devdata.deviceName}</td>
                  <td style={{textAlign:"center"}}>{devdata.model}</td>
                  <td style={{textAlign:"center"}}>{devdata.imeiNumber}</td>
                  <td style={{textAlign: "center"}}>{devdata.mobileNo}</td>
                  <td>{devdata.groupName}</td>
                  <td style={{textAlign:"center"}}>{devdata.timeZone}</td>
                  <td style={{textAlign:"center"}}>{devdata.activationDate}</td>
                  <td style={{textAlign:"center"}}>{devdata.expirationDate}</td>
                  <td style={{textAlign:"center"}}>{devdata.logUpdate}</td>
                  <td style={{textAlign:"center"}}>{devdata.status}</td>
                  <td style={{textAlign:"center", fontSize:"16px"}}>
                  <i onClick={() => showDetailsModal(devdata.deviceID)} style={{ color:"green", cursor:'pointer'}} className="fa-solid fa-list" title="View Details"></i>
                  &nbsp;&nbsp; <i onClick={() => handleEdit(devdata.deviceID)} style={{ color:"#FD0691", cursor:'pointer'}} className="fa-solid fa-pen-to-square" title="Update Details"></i>
               &nbsp;&nbsp; <i onClick={() => showLocationDetailsModal(devdata.deviceID)} style={{ color:"blue", cursor:'pointer'}} className="fa-solid fa-location-dot" title="Monitor"></i>
                {/*  &nbsp;&nbsp;<i onClick={() => showSaleDetailsModal(devdata.deviceID)} style={{ color:"orange", cursor:'pointer'}} className="fas fa-cart-arrow-down" title="Sell"></i>       */}
                  </td>
                </tr>
               );
            })}
            </tbody>
            </table>
            <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount}  onPageChange={ChangePage}  disableInitialCallback={true}
            initialPage={0}  containerClassName={'pagination justify-content-end'} pageClassName={'page-item'} pageLinkClassName={'page-link'}  previousClassName={'page-item'}
            previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'}  breakClassName={'page-item'}  breakLinkClassName={'page-link'}  activeClassName={'active'}></ReactPaginate>       
            </div> </div> 
            </div>
            </div>
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>       
            </>
    );
    }   
export default DeviceList;
